import { languages } from "./languages";

export default {
  0: {
    name: languages.tournamentStatus[0].name,
  },
  1: {
    name: languages.tournamentStatus[1].name,
  },
  2: {
    name: languages.tournamentStatus[2].name,
  },
  3: {
    name: languages.tournamentStatus[3].name,
  },
};
